import { Field, Link, TextOutput } from 'Components/Core';
import { Table } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasNonEmptyValue, valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';

/**
 * A table that shows the information regarding how many times this test has been Imported To A relative Compaction Test.
 * Seperated so the table can be used on it's own.
 */
let AsImportedToRelativeCompactionTable: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const ImportedToRcTests: any[] = useSelector(
    pipe(createWorksheetSelector!('ImportedToRelativeCompactionData'), valueOrDefault([])),
    deepEquals
  );
  return hasNonEmptyValue(ImportedToRcTests) ? (
    <Table
      colWidths={[300, 250]}
      colHeaders={['Test', 'Sample ID']}
      data={ImportedToRcTests?.map((t: any) => [
        <Field input={<TextOutput />} value={'Compaction Control AS 1289.5.4.1 - 2007'} />,
        <Link openInNewTab to={`/worksheets/${t?.TestId}`}>
          {t?.SampleId}
        </Link>,
      ])}
    ></Table>
  ) : (
    <></>
  );
};

AsImportedToRelativeCompactionTable = withInjectedProps(AsImportedToRelativeCompactionTable);

export { AsImportedToRelativeCompactionTable };
